import { CurrencyGbpIcon } from './CurrencyGbpIcon';

/**
 * author: Google
 * id F9BD830F-EBB6-45A4-A576-0DEC27084A95
 * name currency-gbp
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-gbp.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const SterlingIcon = CurrencyGbpIcon;
export default SterlingIcon